'use strict';
//PWC-NOA-310 Checkout shipping and billing step

var addressHelpers = require('./address');
var cleave = require('../components/cleave.js');
var paymentOperator = require('computop/checkout/paymentoperator'); //PWC-NOA-315 integration of payment methods

/**
 * updates the billing address selector within billing forms
 * @param {Object} order - the order model
 * @param {Object} customer - the customer model
 */
function updateBillingAddressSelector(order, customer) {
    var shippings = order.shipping;

    var form = $('form[name$=billing]')[0];
    var $billingAddressSelector = $('.addressSelector', form);
    var hasSelectedAddress = false;

    if ($billingAddressSelector && $billingAddressSelector.length === 1) {
        $billingAddressSelector.empty();
        // Add New Address option
        $billingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
            null,
            false,
            order,
            { type: 'billing' }
        ));

        // Separator -
        $billingAddressSelector.append(addressHelpers.methods.optionValueForAddress(order.resources.shippingAddresses, false, order, {
            // className: 'multi-shipping',
            type: 'billing'
        }));

        shippings.forEach(function (aShipping) {
            var isSelected = order.billing.matchingAddressId === aShipping.UUID;
            hasSelectedAddress = hasSelectedAddress || isSelected;
            // Shipping Address option
            $billingAddressSelector.append(
                addressHelpers.methods.optionValueForAddress(
                    aShipping,
                    isSelected,
                    order,
                    {
                        // className: 'multi-shipping',
                        type: 'billing'
                    }
                )
            );
        });

        if (customer.addresses && customer.addresses.length > 0) {
            $billingAddressSelector.append(addressHelpers.methods.optionValueForAddress(order.resources.accountAddresses, false, order));
            customer.addresses.forEach(function (address) {
                var isSelected = order.billing.matchingAddressId === address.ID;
                hasSelectedAddress = hasSelectedAddress || isSelected;
                // Customer Address option
                $billingAddressSelector.append(
                    addressHelpers.methods.optionValueForAddress({
                        UUID: 'ab_' + address.ID,
                        shippingAddress: address
                    }, isSelected, order, { type: 'billing' })
                );
            });
        }
    }

    $billingAddressSelector.show();
}

/**
 * Updates the billing address form values within payment forms without any payment instrument validation
 * @param {Object} order - the order model
 */
function updateBillingAddress(order) {
    var billing = order.billing;
    if (!billing.billingAddress || !billing.billingAddress.address) return;

    var form = $('form[name=dwfrm_billing]');
    if (!form) return;

    $('input[name$=_firstName]', form).val(billing.billingAddress.address.firstName);
    $('input[name$=_lastName]', form).val(billing.billingAddress.address.lastName);
    $('input[name$=_address1]', form).val(billing.billingAddress.address.address1);
    $('input[name$=_address2]', form).val(billing.billingAddress.address.address2);
    $('input[name$=_address3]', form).val(billing.billingAddress.address.address3);
    $('input[name$=_city]', form).val(billing.billingAddress.address.city);
    $('input[name$=_postalCode]', form).val(billing.billingAddress.address.postalCode);
    $('[name$=_country]', form).val(billing.billingAddress.address.countryCode.value).selectpicker('refresh');
    $('input[name$=_streetNumber]', form).val(billing.billingAddress.address.streetNumber);
    $('select[name$=_title]', form).val(billing.billingAddress.address.title).selectpicker('refresh');
    $('[id$=_APIDistributionCodeDP]', form).val(billing.billingAddress.address.APIDistributionCodeDP);
    $('input[name$=_nameCo]', form).val(billing.billingAddress.address.nameCo);
}

/**
 * Updates the billing address form values with the shipping form information
 * This function will be called only when moving from shipping to billing step
 * This is used when the billing address is the same as the shipping address 
 * @param {Object} order - the order model
 */
function updateBillingWithShippingInformation(order) {
    var shipping = order.shipping;

    if (!shipping || !shipping.length > 0) return;

    var shippingAddress = shipping[0].shippingAddress;
    if (!shippingAddress) return;

    var form = $('form[name=dwfrm_billing]');
    if (!form) return;
    //trigger change to perform fields validation
    $('input[name$=_firstName]', form).val(shippingAddress.firstName).trigger('change');
    $('input[name$=_lastName]', form).val(shippingAddress.lastName).trigger('change');
    $('input[name$=_address1]', form).val(shippingAddress.address1).trigger('change');
    $('input[name$=_address2]', form).val(shippingAddress.address2).trigger('change');
    $('input[name$=_address3]', form).val(shippingAddress.address3).trigger('change');
    $('input[name$=_city]', form).val(shippingAddress.city).trigger('change');
    $('input[name$=_postalCode]', form).val(shippingAddress.postalCode).trigger('change');
    $('[name$=_country]', form).val(shippingAddress.countryCode.value).trigger('change');
    $('input[name$=_streetNumber]', form).val(shippingAddress.streetNumber).trigger('change');
    $('select[name$=_title]', form).val(shippingAddress.title).trigger('change');
    $('[id$=_APIDistributionCodeDP]', form).val(shippingAddress.APIDistributionCodeDP).trigger('change');
    $('input[name$=_nameCo]', form).val(shippingAddress.nameCo).trigger('change');
}

/**
 * Validate and update payment instrument form fields
 * @param {Object} order - the order model
 */
function validateAndUpdateBillingPaymentInstrument(order) {
    var billing = order.billing;
    if (!billing.payment || !billing.payment.selectedPaymentInstruments
        || billing.payment.selectedPaymentInstruments.length <= 0) return;

    var form = $('form[name=dwfrm_billing]');
    if (!form) return;

    var instrument = billing.payment.selectedPaymentInstruments[0];
    $('select[name$=expirationMonth]', form).val(instrument.expirationMonth);
    $('select[name$=expirationYear]', form).val(instrument.expirationYear);
    // Force security code and card number clear
    $('input[name$=securityCode]', form).val('');
    $('input[name$=cardNumber]').data('cleave').setRawValue('');
}

/**
 * Updates the billing address form values within payment forms
 * @param {Object} order - the order model
 */
function updateBillingAddressFormValues(order) {
    module.exports.methods.updateBillingAddress(order);
}

/**
 * clears the billing address form values
 */
function clearBillingAddressFormValues() {
    updateBillingAddressFormValues({
        billing: {
            billingAddress: {
                address: {
                    countryCode: {}
                }
            }
        }
    });
}

/**
 * update billing address summary and contact information
 * @param {Object} order - checkout model to use as basis of new truth
 */
function updateBillingAddressSummary(order) {
    // update billing address summary
    addressHelpers.methods.populateAddressSummary(
        $('.billing .address-summary'),
        order.billing.billingAddress.address
    );

    const activeBillingTypeTxt = $('.js-billing-type-btn.cc-active .js-label').text();
    $('.billing-addr-label').text(activeBillingTypeTxt);

    // update billing parts of order summary
    $('.order-summary-email').text(order.orderEmail);
}

/**
 * Updates the billing information in checkout, based on the supplied order model
 * @param {Object} order - checkout model to use as basis of new truth
 * @param {Object} customer - customer model to use as basis of new truth
 * @param {Object} [options] - options
 */
function updateBillingInformation(order, customer) {
    updateBillingAddressSelector(order, customer);

    //PWC-NOA-313 Checkout digital items
    // update billing address form
    // only copy order data to billing form for regular delivery ('other'); skip for pickup-in-store, dhl-location, prefilled account billing address, or digital-only carts (shipping step skipped)
    const methodEl = document.querySelector('[data-selected-shipping-method]');
    const selectedMethod = methodEl ? methodEl.getAttribute('data-selected-shipping-method') : null;
    const billingForm = document.querySelector('.billing-form');
    const prefilled = billingForm ? billingForm.dataset.billingFormPrefilledWithAccountData === 'true' : false;
    const digitalItemsEl = document.querySelector('[data-cart-contains-only-digital-items]');
    const digitalOnly = digitalItemsEl ? digitalItemsEl.getAttribute('data-cart-contains-only-digital-items') === 'true' : false;
    const cartContainsOnlyGiftcardsEl = document.querySelector('[data-cart-contains-only-giftcard-products]');
    const giftcardsOnly =  cartContainsOnlyGiftcardsEl ? cartContainsOnlyGiftcardsEl.getAttribute('data-cart-contains-only-giftcard-products') === 'true' : false;

    if (!prefilled && selectedMethod === 'other' && !digitalOnly && !giftcardsOnly) {
        updateBillingAddressFormValues(order);
    }

    // update billing address summary and billing parts of order summary
    updateBillingAddressSummary(order);
}

/**
 * reset billing Adress with Shipping Adress
 */
function resetBillingWithShippingInformation() {
    var shipping = $('form.js-shipping-form').serializeArray();

    if (!shipping || !shipping.length > 0) return;

    var shippingAddress = shipping.reduce(function(obj, item) {
        const name = item.name.replace("dwfrm_shipping_shippingAddress_addressFields_", "");
        obj[name] = item.value;
        return obj;
    }, {});

    if (!shippingAddress) return;

    var form = $('form[name=dwfrm_billing]');
    if (!form) return;
    //trigger change to perform fields validation
    $('input[name$=_firstName]', form).val(shippingAddress.firstName).trigger('change');
    $('input[name$=_lastName]', form).val(shippingAddress.lastName).trigger('change');
    $('input[name$=_address1]', form).val(shippingAddress.address1).trigger('change');
    $('input[name$=_address2]', form).val(shippingAddress.address2).trigger('change');
    $('input[name$=_address3]', form).val(shippingAddress.address3).trigger('change');
    $('input[name$=_city]', form).val(shippingAddress.city).trigger('change');
    $('input[name$=_postalCode]', form).val(shippingAddress.postalCode).trigger('change');
    $('[name$=_country]', form).val(shippingAddress.country).trigger('change').selectpicker('refresh');;
    $('input[name$=_streetNumber]', form).val(shippingAddress.streetNumber).trigger('change');
    $('select[name$=_title]', form).val(shippingAddress.title).trigger('change').selectpicker('refresh');;
    $('[id$=_APIDistributionCodeDP]', form).val(shippingAddress.APIDistributionCodeDP).trigger('change');
    $('input[name$=_nameCo]', form).val(shippingAddress.nameCo).trigger('change');
    $('.js-address3-field').addClass('d-none');
}

/**
 * Show or hide the billing address
 * If your billing address does not match the shipping address
 */
function toggleBillingAddress() {
    let billingAddressForm = document.querySelector('.js-billing-address-form');
    if (!billingAddressForm) return; 
    
    let billingAddressFieldset = billingAddressForm.querySelector('.js-billing-address-block');
    let sameAddressAsShipping =  billingAddressForm.querySelector('.js-billing-address-same');
    let differentAddressAsShipping =  billingAddressForm.querySelector('.js-billing-address-different');
    let panConsentWrap = billingAddressForm.querySelector('.cc-form__wrap-pan-consent');
    let submitButton = $(billingAddressForm).find('button[type="submit"]');

    if (!billingAddressForm || !sameAddressAsShipping || !differentAddressAsShipping || !billingAddressFieldset) return;

    sameAddressAsShipping.addEventListener( "click", ev => {
        billingAddressFieldset.classList.add('d-none');
        if (panConsentWrap) {
            panConsentWrap.classList.remove('pt-0');
        }
        $('body').trigger('checkout:clearBillingForm');
        resetBillingWithShippingInformation();
    });

    differentAddressAsShipping.addEventListener( "click", ev => {
        $('body').trigger('checkout:clearBillingForm');
        billingAddressFieldset.classList.remove('d-none');
        if (panConsentWrap) {
            panConsentWrap.classList.add('pt-0');
        }
        $('body').trigger('formValidation:revalidate', ['.js-billing-address-form']);
        submitButton.addClass('cc-disabled').prop('disabled', true);
        const preSelectedCountry = $('#billingCountry').find('option[selected]').val();
        if (preSelectedCountry) {
            $('#billingCountry').selectpicker('val', preSelectedCountry).selectpicker('refresh');
        }
    });
} 



/**
 * Updates the payment information in checkout, based on the supplied order model
 * @param {Object} order - checkout model to use as basis of new truth
 */
function updatePaymentInformation(order) {
    // update payment details
    var $paymentSummary = $('.payment-details');
    var htmlToAppend = '';
    const payNowCCForm = $('.paynow-cc-form'); //PWC-NOA-315 integration of payment methods
    payNowCCForm.hide();

    if (order.billing.payment && order.billing.payment.selectedPaymentInstruments
            && order.billing.payment.selectedPaymentInstruments.length > 0
        ) {
            var paymentMethodData = order.billing.payment.selectedPaymentInstruments[0];
            if (paymentMethodData.paymentMethod === 'CREDIT_CARD'
                || /^PAYMENTOPERATOR_CREDIT_DIRECT/.test(paymentMethodData.paymentMethod)
            ) {
                htmlToAppend += '<span>' + order.resources.cardType + ' '
                    + paymentMethodData.type
                    + '</span><div>'
                    + paymentMethodData.maskedCreditCardNumber
                    + '</div><div><span>'
                    + order.resources.cardEnding + ' '
                    + paymentMethodData.expirationMonth
                    + '/' + paymentMethodData.expirationYear
                    + '</span></div>';
            } else if (/^PAYMENTOPERATOR_/.test(paymentMethodData.paymentMethod)) { //PWC-NOA-315 integration of payment methods
                // fallback for all methods without specific payment information
                htmlToAppend += '<div class="paymentoperator-selected-payment">'
                    + paymentMethodData.paymentMethod
                    + '</div>';
                if (/^PAYMENTOPERATOR_PAYMORROW_/.test(paymentMethodData.paymentMethod)) {
                    paymentOperator.paymorrowInit();
                }
                if (/^PAYMENTOPERATOR_PAYNOW$/.test(paymentMethodData.paymentMethod)) {
                    payNowCCForm.show();
                }
            }
        }
    
    $paymentSummary.empty().append(htmlToAppend);
}

/**
 * clears the credit card form
 */
function clearCreditCardForm() {
    $('input[name$="_cardNumber"]').data('cleave').setRawValue('');
    $('select[name$="_expirationMonth"]').val('');
    $('select[name$="_expirationYear"]').val('');
    $('input[name$="_securityCode"]').val('');
}

// function validateBillingForm() {
//     var validatedFieldsPerForm = {};
//     var form = $('.js-billing-form');
//     var formName = form.attr('name');
//     var submitButton = form.find('button[type="submit"]');

//     var validatedFields = validatedFieldsPerForm[formName] || {};
//     form.find('input.js-form-control, textarea.js-form-control').each(function(index,val) {
//         var field = $(val);
//         var fieldName = field.attr('name');
//         var fieldValue = field.val().trim();
//         if (fieldName === undefined) {
//             return;
//         }
//         validatedFields[fieldName] = fieldValue !== '' ? true : false;
//     });
    
//     validatedFieldsPerForm[formName] = validatedFields;
    
//     var allFieldsValid = Object.values(validatedFieldsPerForm[formName]).every(value => value === true);
    
//     if (allFieldsValid || form.hasClass('cc-novalidate')) {
//         submitButton.removeClass('cc-disabled').prop('disabled', false);
//     } else if (!form.hasClass('cc-novalidate')) {
//         submitButton.addClass('cc-disabled').prop('disabled', true);
//     }
// }

module.exports = {
    methods: {
        updateBillingAddressSelector: updateBillingAddressSelector,
        updateBillingAddressFormValues: updateBillingAddressFormValues,
        clearBillingAddressFormValues: clearBillingAddressFormValues,
        updateBillingInformation: updateBillingInformation,
        updatePaymentInformation: updatePaymentInformation,
        clearCreditCardForm: clearCreditCardForm,
        updateBillingAddress: updateBillingAddress,
        validateAndUpdateBillingPaymentInstrument: validateAndUpdateBillingPaymentInstrument,
        updateBillingAddressSummary: updateBillingAddressSummary,
        updateBillingWithShippingInformation: updateBillingWithShippingInformation,
        toggleBillingAddress: toggleBillingAddress
    },

    selectBillingAddress: function () {
        $('.payment-form .addressSelector').on('change', function () {
            var form = $(this).parents('form')[0];
            var selectedOption = $('option:selected', this);
            var optionID = selectedOption[0].value;

            if (optionID === 'new') {
                // Show Address
                $(form).attr('data-address-mode', 'new');
            } else {
                // Hide Address
                $(form).attr('data-address-mode', 'shipment');
            }

            // Copy fields
            var attrs = selectedOption.data();
            var element;

            Object.keys(attrs).forEach(function (attr) {
                element = attr === 'countryCode' ? 'country' : attr;
                if (element === 'cardNumber') {
                    $('.cardNumber').data('cleave').setRawValue(attrs[attr]);
                } else {
                    $('[name$=' + element + ']', form).val(attrs[attr]);
                }
            });
        });
    },

    handleCreditCardNumber: function () { //PWC-NOA-315 integration of payment methods
        if ($('.cardNumber').length) {
            cleave.handleCreditCardNumber('.cardNumber', '#cardType');
        }
        if ($('.creditDirectCardNumber').length > 0) {
            cleave.handleCreditCardNumber('.creditDirectCardNumber', '#creditDirectCardType');
        }
    },

    santitizeForm: function () { //PWC-NOA-315 integration of payment methods
        $('body').on('checkout:serializeBilling', function (e, data) {
            var serializedForm = cleave.serializeData(data.form);

            data.callback(serializedForm);
        });
    },

    selectSavedPaymentInstrument: function () {
        $(document).on('click', '.saved-payment-instrument', function (e) {
            e.preventDefault();
            $('.saved-payment-security-code').val('');
            $('.saved-payment-instrument').removeClass('selected-payment');
            $(this).addClass('selected-payment');
            $('.saved-payment-instrument .card-image').removeClass('checkout-hidden');
            $('.saved-payment-instrument .security-code-input').addClass('checkout-hidden');
            $('.saved-payment-instrument.selected-payment'
                + ' .card-image').addClass('checkout-hidden');
            $('.saved-payment-instrument.selected-payment '
                + '.security-code-input').removeClass('checkout-hidden');
        });
    },

    addNewPaymentInstrument: function () {
        $('.btn.add-payment').on('click', function (e) {
            e.preventDefault();
            $('.payment-information').data('is-new-payment', true);
            clearCreditCardForm();
            $('.credit-card-form').removeClass('checkout-hidden');
            $('.user-payment-instruments').addClass('checkout-hidden');
        });
    },

    cancelNewPayment: function () {
        $('.cancel-new-payment').on('click', function (e) {
            e.preventDefault();
            $('.payment-information').data('is-new-payment', false);
            clearCreditCardForm();
            $('.user-payment-instruments').removeClass('checkout-hidden');
            $('.credit-card-form').addClass('checkout-hidden');
        });
    },

    clearBillingForm: function () {
        $('body').on('checkout:clearBillingForm', function () {
            clearBillingAddressFormValues();
        });
    },

    paymentTabs: function () {
        $('.payment-options .nav-item').on('click', function (e) {
            e.preventDefault();
            var methodID = $(this).data('method-id');
            $('.payment-information').data('payment-method-id', methodID);
            // dotsource custom: update selected payment method in billing form
            $('input[name$=paymentMethod]').val(methodID);
            // hide other payment methods form
            $('.credit-card-selection-new').find('.tab-pane').removeClass('active');
            var paymentOptionTab = $('[id=' + methodID + '-content');
            if (paymentOptionTab.length) {
                paymentOptionTab.addClass('active');
                if (['PAYMENTOPERATOR_PAYMORROW_INVOICE', 'PAYMENTOPERATOR_PAYMORROW_SDD'].indexOf(methodID) > -1) {
                    paymentOperator.paymorrowInit();
                }

                if (['RIVERTY'].indexOf(methodID) > -1) {
                    $('.user-payment-instruments').addClass('checkout-hidden');
                    $('.credit-card-form').removeClass('checkout-hidden');
                }
            }
        });
    },

    selectCreditCardForPaymentOperatorCreditCard: function () {
        $(document).on('click', '.paymentoperator-creditcard', function (e) {
            e.preventDefault();
            var self = $(this);
            var container = self.parents('.stored-payments');
            $('.paymentoperator-creditcard', container).removeClass('selected-payment');
            self.addClass('selected-payment');
            $('input[name$=paymentoperatorcreditcard_creditcarduuid]').val(self.data('uuid'));
            // default logic: show input form for cvv
            $('.paymentoperator-creditcard .card-image').removeClass('checkout-hidden');
            $('.paymentoperator-creditcard .security-code-input').addClass('checkout-hidden');
            self.find('.card-image').addClass('checkout-hidden');
            self.find('.security-code-input').removeClass('checkout-hidden');
        });
    },

    resetBillingWithShippingInformation: function () {
        $('body').on('checkout:resetBillingWithShippingInformation', function () {
            resetBillingWithShippingInformation();
        });
    },

    requireBillingAddress: function () {
        $('body').on('checkout:requireBillingAddress', function (e, clearForm) {
            let billingAddressForm = document.querySelector('.js-billing-address-form');
            let billingAddressFieldset = billingAddressForm.querySelector('.js-billing-address-block');
            if (clearForm) {
                $('body').trigger('checkout:clearBillingForm');
                $('body').trigger('formValidation:clear', $('.js-billing-address-form').attr('name'));
            }
            billingAddressFieldset.classList.remove('d-none');
            $('.js-billing-address-selector').addClass('d-none');
            $('.js-billing-address-different').prop('checked', true);
            const preSelectedCountry = $('#billingCountry').find('option[selected]').val();
            if (preSelectedCountry) {
                $('#billingCountry').selectpicker('val', preSelectedCountry).selectpicker('refresh');
            }
            $('body').trigger('formValidation:revalidate', ['.js-billing-address-form']);
        });
    },

    enableSameAddressAsShipping: function () {
        $('body').on('checkout:enableSameAddressAsShipping', function () {
            let billingAddressForm = document.querySelector('.js-billing-address-form');
            let billingAddressFieldset = billingAddressForm.querySelector('.js-billing-address-block');
            billingAddressFieldset.classList.add('d-none');
            $('.js-billing-address-selector').removeClass('d-none');
            $('body').trigger('checkout:clearBillingForm');
            $('.js-billing-address-same').prop('checked', true);
        });
    },

    toggleAddress3Field: function () {
        let billingAddressForm = document.querySelector('.js-billing-address-form');
        let countryField = billingAddressForm?.querySelector('.js-billing-country-field');
        $(countryField).on('click', function (clicked) {
            let billingAddressForm = document.querySelector('.js-billing-address-form');
            let countrySelect = billingAddressForm.querySelector('select.js-billing-country-select');
            let address3Field = billingAddressForm.querySelector('.js-address3-field');
            var selectedCountry = $(countrySelect).val();
            if (selectedCountry === 'AT') {
                $(address3Field).removeClass('d-none');
            } else {
                $(address3Field).addClass('d-none');
            }
        });
    }

    /*initBillingAddressAutocomplete: function () {
        if (!window.google) {
            console.error('Google Maps JavaScript API not loaded.');
            return;
        }

        const input = $('#billingAddressOne')[0];

        if (!input) {
            return;
        }
        
        let autocomplete = new google.maps.places.Autocomplete(input, {
            types: ['geocode'],
            componentRestrictions: { country: ['IT'] },
            fields: ['name', 'address_component', 'geometry'],
        });

        google.maps.event.addListener(autocomplete, 'place_changed', function () {
            var place = autocomplete.getPlace();
            if (!place.geometry) {
                return;
            }

            var form = $(input).closest('form');
            var addressComponents = place.address_components;
            $(input).val(place.name).trigger('change');

            for (var i = 0; i < addressComponents.length; i++) {
                var addressType = addressComponents[i].types[0];
                var val = addressComponents[i].long_name;

                if (addressType === 'administrative_area_level_1' || addressType === 'administrative_area_level_2') {
                    val = addressComponents[i].short_name;
                }

                switch (addressType) {
                    case 'locality':
                        $('input[name$=_city]', form).val(val).trigger('change');
                        break;
                    case 'administrative_area_level_2':
                        $('select[name$=_stateCode],input[name$=_stateCode]', form).val(val).trigger('change');
                        $('select[name$=_stateCode],input[name$=_stateCode]', form).selectpicker('refresh');
                        break;
                    case 'postal_code':
                        $('input[name$=_postalCode]', form).val(val).trigger('change');
                        break;
                    default:
                        break;
                }
            }

            validateBillingForm();
        });
    }*/
};
